import * as z from 'zod'
import { USER_EVENT_TYPES } from '../UserEvents.js'
import { PostApiContract } from './ApiContract.js'

const thumbmarkSchema = z
    .object({
        visitorId: z.string().optional(),
        metadata: z
            .object({
                components: z.unknown(),
                info: z.unknown(),
            })
            .optional(),
    })
    .optional()

export const postUserEventSchema = z.looseObject({
    // Use looseObject to allow unknown properties
    eventType: z.enum(Object.values(USER_EVENT_TYPES)),
    tm: thumbmarkSchema,
})

export type ThumbmarkMetadata = z.infer<typeof thumbmarkSchema>

export interface PostUserEventRequest extends PostApiContract {
    Body: z.infer<typeof postUserEventSchema>
    Response: object
    ResponseJson: object
}
